/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { ConfiguracionProvider } from "./ConfiguracionContext";
import { LayoutProvider } from "./LayoutContext";
import { RequestProvider } from "./RequestContext";
import { SesionProvider } from "./SesionContext";
import { TimeSetExecutionProvider } from "./timeSetExecution"
import { HelpProvider } from "./HelpContext";

export const AllSystemProvider = (props) => (
  <ConfiguracionProvider>
    <LayoutProvider>
      <RequestProvider>
        <SesionProvider>
          <TimeSetExecutionProvider>
            <HelpProvider>
              {props.children}
            </HelpProvider>
          </TimeSetExecutionProvider>
        </SesionProvider>
      </RequestProvider>
    </LayoutProvider>
  </ConfiguracionProvider>
);
